import sanitizeHtml from 'sanitize-html';

export const isBlockedDomain = (urlOrCode: string) => {
  const blackRegex = [/wetravel/];
  return blackRegex.some((regex) => regex.test(urlOrCode));
};

export const validateUrl = (url: string) => {
  try {
    new URL(url);
    return true;
  } catch {
    return false;
  }
};

const config = {
  allowedTags: sanitizeHtml.defaults.allowedTags.concat(['iframe', 'script', 'style']),
  allowedAttributes: {
    '*': ['class', 'style', 'id', 'width', 'height'],
    iframe: [
      'src',
      'frameborder',
      'allowfullscreen',
      'scrolling',
      'marginheight',
      'marginwidth',
      'allow',
      'title',
      'style',
    ],
    script: ['type'],
    style: ['type'],
  },
  allowVulnerableTags: true,
  parseStyleAttributes: true,
};

/**
 * An HTML document string used as the srcDoc for an outer iframe.
 * This document sets the html and body elements to 100% height with zero margins,
 * ensuring that the embedded child iframe fills the entire height of the parent iframe.
 */
export const createUrlSource = (url: string): string => `
<!DOCTYPE html>
<html style="height: 100%;">
  <head>
    <meta charset="utf-8" />
    <style>
      html, body { height: 100%; margin: 0; }
      iframe { width: 100%; height: 100%; border: none; }
    </style>
  </head>
  <body style="margin: 0;">
    <iframe
      allow="clipboard-write"
      allowFullScreen
      src="${url}"
      sandbox="allow-scripts allow-same-origin"
      title="Embed URL"
    />
  </body>
</html>
`;

export const createHtmlSource = (html: string): string =>
  sanitizeHtml(html, config) +
  '<style> html, body { height: 100%; width: 100%; margin: 0; overflow: hidden; } iframe { border: none; height: 100%; width: 100%; } </style>';
